import * as React from "react"
export const StarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={16}
    height={16}
    className="fill-primary-3"
    fill="none"
    {...props}>
    <path
      fill="inherit"
      d="M6.575 2.793c.46-.902.69-1.352 1-1.498a1 1 0 0 1 .85 0c.31.146.54.596 1 1.498l.973 1.906 2.114.336c1 .16 1.5.239 1.733.488a1 1 0 0 1 .263.81c-.042.34-.4.697-1.115 1.413L11.88 9.261l.334 2.114c.157 1 .236 1.5.071 1.8a1 1 0 0 1-.688.5c-.336.064-.787-.166-1.69-.624L8 12.08l-1.908.97c-.902.46-1.353.689-1.689.625a1 1 0 0 1-.688-.5c-.165-.3-.086-.8.071-1.8l.334-2.114-1.513-1.515c-.715-.716-1.073-1.074-1.115-1.413a1 1 0 0 1 .263-.81c.234-.25.734-.329 1.733-.488L5.602 4.7l.973-1.906Z"
    />
  </svg>
)
